import W from "lodash-es/cloneDeep";
import { resolveComponent as d, createElementBlock as o, openBlock as a, normalizeClass as r, createElementVNode as u, createCommentVNode as n, createVNode as S, toDisplayString as _, createBlock as h, withCtx as m, createTextVNode as T, renderSlot as f, TransitionGroup as F, resolveDirective as O, withDirectives as E, withKeys as q, normalizeStyle as Y, Fragment as J, renderList as Q, mergeProps as X, resolveDynamicComponent as Z, computed as $ } from "vue";
import ee from "./useSearch.js";
import { CSS_VARS as L, LLLV_CHANGE_TRIGGERS as b } from "./constants.js";
import V from "./directives/sticky.js";
import { t as w } from "./locale.js";
import { persistentStorage as A } from "./storage.js";
import { getCssVar as D, sortItems as te, filterItems as se } from "./utils/helpers.js";
import le from "./Badge.js";
import v from "./Button.js";
import R from "./Checkbox.js";
import ie from "./Dropdown.js";
import { _ as N } from "./Expand.vue_vue_type_script_setup_true_lang-CiONJfAp.js";
import re from "./Filters.js";
import B from "./Icon.js";
import ae from "./Input.js";
import ne from "./Paginate.js";
import { _ as k } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import oe from "./EmptyState.js";
import ce from "./Loading.js";
const de = "_checkbox_hsxyw_10", he = "_actions_hsxyw_14", ue = {
  "select-bar": "_select-bar_hsxyw_2",
  checkbox: de,
  actions: he
}, me = {
  name: "bulk-actions",
  components: {
    "ll-button": v,
    "ll-checkbox": R
  },
  props: {
    allowSelectAll: Boolean,
    isAllPageChecked: Boolean,
    isSomePageChecked: Boolean,
    hideBulkActionOptions: Boolean,
    hideNumberOfTotalSelected: Boolean,
    totalCount: {
      type: Number,
      default: 0
    },
    totalSelectedCount: {
      type: Number,
      default: 0
    }
  },
  emits: ["change:select-current", "change:select-all", "change:clear-selected"],
  data: function() {
    return {
      selectAllText: w("ll.listView.selectAll")
    };
  },
  computed: {
    clearSelectedText() {
      return this.allowSelectAll ? w("ll.listView.deselectAllCount", { count: this.totalCount }) : w("ll.listView.clearSelection");
    },
    showSelectAll() {
      return [this.totalSelectedCount !== this.totalCount, this.allowSelectAll].every(Boolean);
    },
    numberOfTotalSelectedText() {
      return w("ll.listView.numberOfTotalSelected", {
        num: this.totalSelectedCount,
        total: this.totalCount
      });
    },
    selectAllCountText() {
      return w("ll.listView.selectAllCount", { count: this.totalCount });
    },
    numItemsSelectedText() {
      return w("ll.listView.numItemsSelected", {
        totalSelectedCount: this.totalSelectedCount,
        totalCount: this.totalCount
      });
    }
  },
  methods: {
    onSelectPage(e) {
      this.$emit("change:select-current", e);
    },
    selectAll() {
      this.$emit("change:select-all");
    },
    clearSelected() {
      this.$emit("change:clear-selected");
    }
  }
}, ge = {
  key: 0,
  class: "tw-flex tw-flex-1 tw-items-center tw-justify-between"
}, fe = {
  key: 0,
  class: "tw-text-xs"
}, Se = {
  key: 1,
  class: "tw-ml-1.5 lg:tw-hidden"
};
function ye(e, l, s, p, i, t) {
  const c = d("ll-checkbox"), g = d("ll-button");
  return a(), o("div", {
    class: r(["lg:tw-flex", [
      e.$style["select-bar"],
      {
        "lg:tw-hidden": s.hideBulkActionOptions
      },
      "tw-p-3"
    ]])
  }, [
    u("div", {
      class: r(["tw-flex tw-items-center", {
        "tw-justify-between": !s.hideBulkActionOptions
      }])
    }, [
      S(c, {
        "data-test": "checkbox|bulk-actions",
        class: r([e.$style.checkbox, "tw-m-0 lg:tw-hidden"]),
        checked: s.isSomePageChecked && !!s.totalCount,
        indeterminate: s.isSomePageChecked && !s.isAllPageChecked,
        label: s.totalSelectedCount ? "" : e.selectAllText,
        "onUpdate:checked": t.onSelectPage
      }, null, 8, ["class", "checked", "indeterminate", "label", "onUpdate:checked"]),
      s.totalSelectedCount && !s.hideBulkActionOptions ? (a(), o("div", ge, [
        s.hideNumberOfTotalSelected ? n("", !0) : (a(), o("div", fe, _(t.numberOfTotalSelectedText), 1)),
        u("div", {
          class: r({ "tw-ml-3": !s.hideNumberOfTotalSelected })
        }, [
          t.showSelectAll ? (a(), h(g, {
            key: 0,
            inline: "",
            onClick: t.selectAll
          }, {
            default: m(() => [
              T(_(t.selectAllCountText), 1)
            ]),
            _: 1
          }, 8, ["onClick"])) : (a(), h(g, {
            key: 1,
            inline: "",
            onClick: t.clearSelected
          }, {
            default: m(() => [
              T(_(t.clearSelectedText), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        ], 2)
      ])) : s.hideBulkActionOptions && s.totalSelectedCount ? (a(), o("div", Se, [
        u("h4", null, _(t.numItemsSelectedText), 1)
      ])) : n("", !0)
    ], 2),
    s.totalSelectedCount && !s.hideBulkActionOptions ? (a(), o("div", {
      key: 0,
      class: r(e.$style.actions)
    }, [
      f(e.$slots, "bulk-actions-content")
    ], 2)) : n("", !0)
  ], 2);
}
const we = {
  $style: ue
}, pe = /* @__PURE__ */ k(me, [["render", ye], ["__cssModules", we]]), _e = {
  "empty-state": "_empty-state_12gjn_2"
}, be = {
  name: "loading-manager",
  components: {
    EmptyState: oe,
    Loading: ce
  },
  props: {
    emptyStateText: {
      type: String,
      default: ""
    },
    loading: Boolean,
    results: {
      type: Array,
      default: () => []
    }
  }
};
function ke(e, l, s, p, i, t) {
  const c = d("Loading"), g = d("EmptyState");
  return s.loading ? (a(), h(c, {
    key: 0,
    class: "tw-bg-white"
  })) : s.results.length ? (a(), h(F, {
    key: 1,
    name: "slide-y",
    tag: "ul"
  }, {
    default: m(() => [
      f(e.$slots, "default")
    ]),
    _: 3
  })) : (a(), h(g, {
    key: 2,
    class: r(["tw-bg-white", e.$style["empty-state"]]),
    text: s.emptyStateText
  }, null, 8, ["class", "text"]));
}
const Ce = {
  $style: _e
}, Te = /* @__PURE__ */ k(be, [["render", ke], ["__cssModules", Ce]]), Ie = {
  "main-header": "_main-header_1wlsh_2",
  "expanded-content-wrapper": "_expanded-content-wrapper_1wlsh_18",
  "expanded-content-header": "_expanded-content-header_1wlsh_29",
  "expanded-content-header-grid": "_expanded-content-header-grid_1wlsh_52",
  "expansion-toggle-button": "_expansion-toggle-button_1wlsh_70",
  "list-group": "_list-group_1wlsh_74",
  "expanded-content-list-items-wrapper": "_expanded-content-list-items-wrapper_1wlsh_81"
}, xe = {
  name: "list-group",
  components: {
    Expand: N,
    "ll-button": v,
    Icon: B
  },
  directives: {
    sticky: V
  },
  props: {
    /**
     * Disables the gutters between adjacent ListGroup components.
     */
    disableExternalGutters: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows the list items to be collapsed
     */
    isCollapsible: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows the expanded content to be collapsed by default.
     * Note: has no effect unless the `isCollapsible` prop is `true`.
     */
    isCollapsedByDefault: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    const e = !this.isCollapsible || !this.isCollapsedByDefault;
    return {
      isExpanded: e,
      isDoneExpanding: e
    };
  },
  computed: {
    headerOffset() {
      return parseFloat(D(L.TOP_HEADER_HEIGHT));
    }
  },
  methods: {
    toggleExpand() {
      this.isCollapsible && (this.isExpanded = !this.isExpanded, this.isExpanded || (this.isDoneExpanding = !1));
    },
    onHeaderClick(e) {
      this.$refs.actionsContainer.contains(e.target) || this.toggleExpand();
    }
  }
}, ve = { class: "tw-flex-auto" }, Be = { ref: "actionsContainer" };
function Ae(e, l, s, p, i, t) {
  const c = d("Icon"), g = d("ll-button"), I = d("Expand"), x = O("sticky");
  return a(), o("div", {
    class: r([
      e.$style["list-group"],
      {
        [e.$style["disable-external-gutters"]]: s.disableExternalGutters,
        [e.$style["is-collapsed"]]: !i.isExpanded
      }
    ])
  }, [
    u("header", {
      class: r(["tw-flex tw-items-center", [e.$style["main-header"], { "tw-cursor-pointer": s.isCollapsible }]]),
      onClick: l[0] || (l[0] = (...C) => t.onHeaderClick && t.onHeaderClick(...C))
    }, [
      s.isCollapsible ? (a(), h(g, {
        key: 0,
        class: r(["tw-mr-1.5 tw-text-ice-900", e.$style["expansion-toggle-button"]]),
        icon: ""
      }, {
        default: m(() => [
          S(c, {
            class: r([i.isExpanded ? "tw-rotate-270" : "rotate-180"]),
            name: "chevron-left"
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["class"])) : n("", !0),
      u("div", ve, [
        f(e.$slots, "title")
      ]),
      u("div", Be, [
        f(e.$slots, "actions")
      ], 512)
    ], 2),
    S(I, {
      "is-expanded": i.isExpanded,
      onAfterExpand: l[1] || (l[1] = (C) => i.isDoneExpanding = !0)
    }, {
      default: m(() => [
        u("div", {
          class: r(e.$style["expanded-content-wrapper"])
        }, [
          e.$slots["expanded-content-list-header"] ? E((a(), o("header", {
            key: 0,
            class: r(e.$style["expanded-content-header"])
          }, [
            u("div", {
              class: r(["tw-ll-grid tw-flex-1", e.$style["expanded-content-header-grid"]])
            }, [
              f(e.$slots, "expanded-content-list-header")
            ], 2)
          ], 2)), [
            [x, i.isExpanded && i.isDoneExpanding ? t.headerOffset : 0]
          ]) : n("", !0),
          u("div", {
            class: r(e.$style["expanded-content-list-items-wrapper"])
          }, [
            S(F, {
              name: "fade",
              mode: "out-in"
            }, {
              default: m(() => [
                f(e.$slots, "expanded-content-list-items")
              ]),
              _: 3
            })
          ], 2)
        ], 2)
      ]),
      _: 3
    }, 8, ["is-expanded"])
  ], 2);
}
const Pe = {
  $style: Ie
}, gt = /* @__PURE__ */ k(xe, [["render", Ae], ["__cssModules", Pe]]), Fe = "_caret_1147a_2", Oe = {
  "caret-up": "_caret-up_1147a_2",
  "caret-down": "_caret-down_1147a_6",
  caret: Fe
}, Ee = {
  name: "list-header",
  components: {
    "ll-icon": B
  },
  props: {
    /**
     * keys to be sorted for the column
     * the first key should be the default sort value
     */
    sortKeys: {
      type: Array,
      required: !0,
      validator: (e) => e.length === 2
    },
    listViewRef: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isAscending: null
    };
  },
  computed: {
    listViewInstance() {
      return this.listViewRef || this.$parent;
    },
    /**
     * Is the column currently sorted
     */
    isSorted() {
      return this.sortKeys.includes(this.listViewInstance.sortTerm);
    },
    /**
     * Show the top icon if it's not sorted or if the current sortTerm matches
     */
    showCaretUp() {
      return this.isAscending === null || this.sortKeys[0] === this.listViewInstance.sortTerm;
    },
    /**
     * Show the bottom icon if it's not sorted or if the current sortTerm matches
     */
    showCaretDown() {
      return this.isAscending === null || this.sortKeys[1] === this.listViewInstance.sortTerm;
    }
  },
  watch: {
    isSorted: {
      handler(e) {
        this.isAscending = e ? !0 : null;
      },
      immediate: !0
    }
  },
  methods: {
    /**
     * Sorts the column by the sort field
     */
    sort() {
      this.listViewInstance.onSort(this.sortKeys[this.isAscending ? 1 : 0]), this.isAscending = !this.isAscending;
    }
  }
};
function Le(e, l, s, p, i, t) {
  const c = d("ll-icon");
  return a(), o("div", {
    class: r(["tw-cursor-pointer", { "tw-bg-blue-100": t.isSorted }]),
    onClick: l[0] || (l[0] = (...g) => t.sort && t.sort(...g))
  }, [
    f(e.$slots, "default"),
    u("div", {
      class: r(["h-4 w-3 tw-relative tw-text-ice-700", { "is-active-sort": t.isSorted }])
    }, [
      t.showCaretUp ? (a(), h(c, {
        key: 0,
        name: "caret-up",
        class: r(["tw-absolute", [e.$style.caret, e.$style["caret-up"]]]),
        size: "dense"
      }, null, 8, ["class"])) : n("", !0),
      t.showCaretDown ? (a(), h(c, {
        key: 1,
        name: "caret-down",
        class: r(["tw-absolute", [e.$style.caret, e.$style["caret-down"]]]),
        size: "dense"
      }, null, 8, ["class"])) : n("", !0)
    ], 2)
  ], 2);
}
const Ve = {
  $style: Oe
}, ft = /* @__PURE__ */ k(Ee, [["render", Le], ["__cssModules", Ve]]), De = "_header_c8ut0_25", Re = "_separator_c8ut0_1", Ne = "_dropdown_c8ut0_199", ze = {
  "list-items": "_list-items_c8ut0_2",
  "legacy-box": "_legacy-box_c8ut0_16",
  header: De,
  "header-grid-container": "_header-grid-container_c8ut0_75",
  "header-grid": "_header-grid_c8ut0_75",
  "search-input": "_search-input_c8ut0_109",
  "clear-button": "_clear-button_c8ut0_120",
  "search-button": "_search-button_c8ut0_134",
  "total-sort": "_total-sort_c8ut0_151",
  "filter-toggle-btn": "_filter-toggle-btn_c8ut0_158",
  "filter-toggle-btn-with-hint-text": "_filter-toggle-btn-with-hint-text_c8ut0_162",
  "filters-expand": "_filters-expand_c8ut0_177",
  "filters-wrapper": "_filters-wrapper_c8ut0_178",
  separator: Re,
  "filters-half-width": "_filters-half-width_c8ut0_191",
  dropdown: Ne,
  "sort-option": "_sort-option_c8ut0_203",
  "select-all": "_select-all_c8ut0_207"
}, P = {
  isSearchable: !0,
  placeholder: "Search",
  searchBy: ["name"]
}, He = {
  name: "ll-list-view",
  components: {
    BulkActions: pe,
    Filters: re,
    Paginate: ne,
    LoadingManager: Te,
    Badge: le,
    Button: v,
    Icon: B,
    Dropdown: ie,
    Expand: N,
    Checkbox: R,
    Input: ae
  },
  directives: {
    sticky: V
  },
  inject: {
    trackSearch: { default: () => () => {
    } },
    trackFilters: { default: () => () => {
    } },
    trackSort: { default: () => () => {
    } },
    trackResults: { default: () => () => {
    } }
  },
  props: {
    /**
     * Hide the '{number} of {total} selected' text for bulk actions
     */
    hideNumberOfTotalSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Hide the Select All checkbox for bulk actions
     */
    hideSelectAll: {
      type: Boolean,
      default: !1
    },
    /**
     * Text to render in EmptyState component if there are no results
     */
    emptyStateText: {
      type: String,
      default: ""
    },
    filterSchema: {
      type: Array,
      default: () => []
    },
    /**
     * Make search fuzzy. Only for client side search.
     */
    fuzzySearch: {
      type: Boolean,
      default: !1
    },
    hideTotal: Boolean,
    initialPage: {
      type: Number,
      default: void 0
    },
    /**
     * Can items on the page be selected for bulk actions
     */
    isSelectable: Boolean,
    /**
     * For loading data already paginated, filtered (including search), and sorted from a backend.
     * Defining this prop will disable the built-in search, filtering, sorting and pagination.
     * You will instead need to use the available events (`@change`, and `@change:` prefixed)
     * to know when to request new pages from your backend.
     * This requires providing `totalItemCount`.
     * Use the loading prop to indicate when data is being loaded.
     */
    isServerSide: Boolean,
    /**
     * The data for each row. Used in this file as this.internalItems (a copy) to allow mutation;
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Default field to track selected items by
     */
    itemTrackBy: {
      type: String,
      default: "id"
    },
    loading: Boolean,
    // Number of items to display per page
    pageSize: {
      type: Number,
      default: 50
    },
    searchSchema: {
      type: Object,
      default: () => ({})
    },
    // Provide an optional custom 'Sort by' label
    sortLabel: {
      type: String,
      default: () => w("ll.listView.sortBy")
    },
    sortOnLoad: Boolean,
    sorts: {
      type: Object,
      default: () => ({})
    },
    /**
     * Total number of unpaginated results
     * Required when `isServerSide` is `true`
     */
    totalItemCount: {
      type: Number,
      default: void 0
    },
    /**
     * Validation schema function that returns an object
     */
    validationSchema: {
      type: Function,
      default: () => () => {
      }
    },
    /**
     * Whether to disable the sticky filters
     * if disabled, the following will happen
     * 1. pre-selected value(s) can be added to
     * the filter component's attributes to overwrite the sticky filters
     * 2. users will not have sticky filters on the page
     */
    disablePersistency: Boolean,
    /**
     * Whether to disable the ability of saving 'show-filters'
     * in local storage
     */
    disableShowFilter: Boolean,
    /**
     * Whether to disable the stickiness of the header.
     * Default is false. When true, neither the list headers nor
     * the bulk actions (when applicable) will be sticky.
     */
    disableStickyHeader: Boolean,
    /**
     * Whether to expand the filters section by default on load.
     */
    showFiltersOnLoad: Boolean,
    /**
     * Do not use the LoadingManager, and instead render the default slot as passed
     */
    disableLoader: {
      type: Boolean,
      default: !1
    },
    /**
     * Override the header offset used to position the sticky header
     */
    stickyHeaderOffset: {
      type: Number,
      default: null
    },
    /**
     * Prevent bulk actions dropdown from rendering
     */
    hideBulkActionOptions: {
      type: Boolean,
      default: !1
    },
    /**
     * If initial search term is provided, the list will be filtered on load.
     */
    initialSearchTerm: {
      type: String,
      default: ""
    },
    /**
     * Function that determines whether the item checkbox is disabled or not (default: false)
     */
    isItemDisabled: {
      type: Function,
      default: () => !1
    }
  },
  emits: [
    "change",
    "change:filter",
    "change:page",
    "change:search",
    "change:sort",
    "change:reset",
    "filters-toggle-click",
    "select-all",
    "deselect-all",
    "update-filters",
    "updateResults"
  ],
  data() {
    var e;
    return {
      internalItems: [],
      currentPage: this.initialPage || 1,
      // TODO: fetch from query params
      previousPage: null,
      sortOptionsWidth: 0,
      filters: {},
      filterText: w("ll.filter"),
      searchFor: () => {
      },
      // initialized in the watch handler for internalItems
      searchTerm: this.initialSearchTerm,
      searchText: w("ll.search"),
      sortTerm: "",
      isLoadingSearchSchemaAction: !1,
      isShowingFilters: !!((e = this.filterSchema) != null && e.length && (this.showFiltersOnLoad || A.get("show-filters"))),
      isFiltering: !1,
      results: [],
      selectedItems: []
    };
  },
  computed: {
    /**
     * Returns true if any of its list items are truthy; otherwise returns false.
     * @returns {boolean}
     */
    isLoading() {
      return [this.loading, this.isLoadingSearchSchemaAction, this.isFiltering].some(Boolean);
    },
    totalCount() {
      return this.isServerSide ? this.totalItemCount : this.results.length;
    },
    /**
     * Helps determine if the list is filtered or not when there is an incomplete
     * result list, such as when isServerSide is true.
     */
    isFiltered() {
      return !!(this.numberOfFilters || this.searchTerm);
    },
    /**
     * Merges the searchSchema with the default value since all attributes are optional
     */
    internalSearchSchema() {
      return {
        ...P,
        searchBy: !this.searchSchema.isSearchable && P.searchBy,
        ...this.searchSchema
      };
    },
    /**
     * Start of page
     */
    startIndex() {
      return this.pageSize * (this.currentPage - 1);
    },
    /**
     * End of page
     */
    endIndex() {
      return this.startIndex + this.pageSize;
    },
    /**
     * Slices the results set into a paginated segment.
     * @returns One page in the paginated set of results
     */
    paginated() {
      let e;
      if (this.isServerSide)
        e = this.results;
      else {
        const { endIndex: l, totalCount: s, results: p, startIndex: i } = this;
        e = p.slice(i, Math.min(l, s));
      }
      return this.$emit("updateResults", e), e;
    },
    /**
     * Displays a visual indication for the number of results, or "working" if the
     * results are being determined.
     */
    total() {
      const e = this.pageSize * (this.currentPage - 1), l = this.paginated.length ? `${e + 1} - ${e + this.paginated.length}` : 0;
      return this.isLoading ? w("ll.listView.calculating") : w("ll.listView.totalResults", { num: String(l), total: String(this.totalCount) });
    },
    /**
     * Determines if both #list-header and #list-items slots are used.
     * @returns {boolean}
     */
    useDefinedSlots() {
      return !!this.$slots["list-header"] && !!this.$slots["list-items"];
    },
    /**
     * Don't show total count if list items are selected and total is not hidden
     */
    shouldShowTotal() {
      return !this.totalSelectedCount && !this.hideTotal;
    },
    /**
     * Returns a list of the selected items' track by field
     */
    selectedItemIds() {
      return this.selectedItems.map((e) => e[this.itemTrackBy]);
    },
    /**
     * Returns a list of the paginated items' track by field
     */
    paginatedIds() {
      return this.paginated.map((e) => e[this.itemTrackBy]);
    },
    isAllPageChecked() {
      return this.isServerSide ? this.totalCount > 0 && this.totalCount === this.selectedItemIds.length : this.totalCount > 0 && this.paginatedIds.every((e) => this.selectedItemIds.includes(e));
    },
    isSomePageChecked() {
      return this.isServerSide ? this.totalCount > 0 && this.selectedItemIds.length > 0 : this.totalCount > 0 && this.paginatedIds.some((e) => this.selectedItemIds.includes(e));
    },
    numberOfFilters() {
      return Object.keys(this.filters).reduce((e, l) => {
        const s = this.filters[l].filterBy, p = typeof s[0] == "boolean", i = this.filters[l].filterType === "ll-checkbox", t = !this.filters[l].filterType.length, c = this.filters[l].filterType === "ll-input-options" && s[0] === "";
        return t || c ? e : p || typeof s[0] == "string" ? e + (s[0] || !i ? 1 : 0) : e + (s.length || 0);
      }, 0);
    },
    isSelectBarVisible() {
      return !!this.totalSelectedCount;
    },
    showPrimaryControls() {
      return this.internalSearchSchema.isSearchable || this.filterSchema.length;
    },
    showSecondaryControls() {
      return !!this.$slots["secondary-controls"];
    },
    isSortable() {
      return Object.keys(this.sorts).length > 0;
    },
    totalSelectedCount() {
      return this.selectedItems.length;
    },
    headerOffset() {
      return this.disableStickyHeader ? null : this.stickyHeaderOffset ?? parseFloat(D(L.TOP_HEADER_HEIGHT));
    }
  },
  watch: {
    isShowingFilters(e) {
      this.disableShowFilter || A.set("show-filters", e);
    },
    items: {
      handler() {
        this.internalItems = W(this.items);
      },
      immediate: !0,
      deep: !0
    },
    internalItems: {
      handler() {
        if (this.isServerSide) {
          this.results = this.internalItems, this.trackResults({
            page: this.currentPage,
            results: this.results,
            search: this.searchTerm
          });
          return;
        }
        const { searchFor: e } = ee({
          items: $(() => this.internalItems),
          fieldNames: this.internalSearchSchema.searchBy.length ? this.internalSearchSchema.searchBy : [this.displayBy],
          trackBy: this.itemTrackBy
        });
        this.searchFor = (l) => e(l, { fuzzy: this.fuzzySearch }), this.processResults();
      },
      immediate: !0
    },
    sortTerm() {
      this.isServerSide || this.processResults();
    },
    sorts: {
      handler(e) {
        const l = Object.keys(e);
        this.sortTerm = this.sortOnLoad && l.length ? l[0] : "";
      },
      immediate: !0
    }
  },
  created() {
    if (this.isServerSide) {
      if (this.totalItemCount === void 0)
        throw new Error("`totalItemCount` is required when `isServerSide` is `true`.");
      return;
    }
    if (this.searchSchema.action && this.internalItems.length)
      throw new Error("You must pass either `action` or `items`, not both.");
    this.searchTerm && this.onSearch();
  },
  methods: {
    /**
     * Processes the results with searchFor, filterItems, and/or sortItems.
     * Skipped when isServerSide is true because results are pre-processed.
     * @returns {Promise<void>}
     */
    async processResults() {
      if (this.searchSchema.action) {
        this.isLoadingSearchSchemaAction = !0;
        let e;
        try {
          e = await this.searchSchema.action({ search: this.searchTerm });
        } finally {
          this.isLoadingSearchSchemaAction = !1;
        }
        this.results = this.sortItems(this.filterItems((e == null ? void 0 : e.results) || []));
      } else
        this.results = this.sortItems(this.filterItems(this.searchFor(this.searchTerm)));
      this.trackResults({
        page: this.currentPage,
        results: this.results,
        search: this.searchTerm
      });
    },
    /**
     * Filters the list of `items` based on options selected in the `filters` object
     * @param {array} items A list of items to filter.
     * @returns list of items filtered by the applied filters
     */
    filterItems(e) {
      return se(e, this.filters);
    },
    /**
     * Sorts a list of items based on options selected in the `sorts` object
     * @param {array} items A list of items to sort.
     * @returns list of items sorted according to the sort term.
     */
    sortItems(e) {
      return this.sortTerm ? te(e, this.sorts[this.sortTerm]) : e;
    },
    change({ trigger: e = "" } = {}) {
      const { currentPage: l, filters: s, isFiltered: p, pageSize: i, searchTerm: t, sortTerm: c } = this, g = {
        filters: s,
        isFiltered: p,
        page: {
          number: l,
          previousNumber: this.previousPage,
          size: i
        },
        search: t,
        sort: c,
        trigger: e
      };
      this.$emit("change", g);
    },
    /**
     * Clear search term and reset results to their initial state
     */
    async clearSearchTerm() {
      var e, l;
      this.searchTerm = "", await ((l = (e = this.$attrs).onSearchTermClear) == null ? void 0 : l.call(e)), this.onSearch();
    },
    /**
     * Resets the results to their initial state on page load
     */
    reset() {
      if (this.$emit("change:reset"), this.searchTerm = "", this.setPage({ pageNumber: 1 }), this.isServerSide) {
        this.change({ trigger: b.RESET });
        return;
      }
      this.processResults();
    },
    onSearchTermChange() {
      var e, l;
      (l = (e = this.$attrs).onSearchTermChange) == null || l.call(e, this.searchTerm);
    },
    /**
     * Event handler for when the user:
     *  - clicks the Search button
     *  - presses the enter key while focused on the search input
     * Calls a method in Filters that triggers `this.onFilter`. This is necessary
     * in order to persist the filters in local storage, which is handled internally
     * by Filters.
     */
    onSearch() {
      this.$refs.llFilters.applyFilters({ trigger: b.SEARCH });
    },
    /**
     * Event handler for when the user:
     *  - clicks the Apply button
     *  - clicks the Search button (from `this.onSearch`)
     *  - presses the enter key while focused on the search input (from `this.onSearch`)
     * @see: SELL-350
     * @param {object} [options] - optional parameters
     * @param {string} [options.trigger] - what caused the changes
     * @returns {Promise<void>}
     */
    async onFilter({ trigger: e = b.APPLY } = {}) {
      if (this.setPage({ pageNumber: 1 }), this.change({ trigger: e }), this.trackSearch(this.searchTerm), this.trackFilters(this.filters), this.selectedItems = [], !this.isServerSide) {
        try {
          this.isFiltering = !0, await this.processResults({ trigger: e });
        } finally {
          this.isFiltering = !1;
        }
        this.$emit("change:search", this.searchTerm), this.$emit("change:filter", this.filters), this.$emit("update-filters", this.filters), this.clearSelected();
      }
    },
    onFiltersToggleClick() {
      this.isShowingFilters = !this.isShowingFilters, this.$emit("filters-toggle-click", {
        isShowingFilters: this.isShowingFilters
      });
    },
    /**
     * Extend the dropdown list so it does not shift when
     * the options drawer is open
     */
    onSortToggle() {
      this.$nextTick(() => {
        this.sortOptionsWidth = `${this.$refs.sortOptions.clientWidth + 36}px`;
      });
    },
    /**
     * Executes any side-effects when the sort `term` is changed
     * Always fires `change` automatically.
     * @param {string} term The updated sort term
     */
    onSort(e) {
      e !== this.sortTerm && (this.sortTerm = e, this.$emit("change:sort", e), this.trackSort(e), this.clearSelected(), this.setPage({ pageNumber: 1 }), this.change({ trigger: b.SORT }));
    },
    /**
     * Sets current page for the Paginator.
     * @param {Object} data
     * @param {number} data.pageNumber - the page number
     * @param {boolean} data.forceChange - flag to force the change
     */
    setPage({ pageNumber: e, forceChange: l = !1 } = {}) {
      this.previousPage = this.currentPage, this.currentPage = e, this.isServerSide || this.$emit("change:page", e), l && this.change({ trigger: b.PAGE });
    },
    /**
     * Set the scroll position to the top of the list view.
     */
    scrollToTop() {
      this.$refs.scrollTarget && this.$refs.scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    onPaginateSetPage(e) {
      this.setPage({ pageNumber: e, forceChange: !0 }), this.scrollToTop();
    },
    /**
     * Selects or deselects all items on a page
     */
    onSelectPage(e) {
      if (this.$emit("select-all", e), e) {
        const l = Array.from(/* @__PURE__ */ new Set([...this.selectedItems, ...this.paginated]));
        this.selectedItems = this.selectItems(l);
      } else
        this.selectedItems = this.selectedItems.filter((l) => !this.paginatedIds.includes(l[this.itemTrackBy]));
    },
    selectAll() {
      this.selectedItems = this.selectItems(this.results);
    },
    /**
     * Selects one item
     */
    onSelectItem({ item: e, value: l }) {
      this.isItemDisabled(e) || (l ? this.selectedItems.push(e) : this.selectedItems = this.selectedItems.filter(
        (s) => s[this.itemTrackBy] !== e[this.itemTrackBy]
      ));
    },
    /**
     * Clears current selected items
     */
    clearSelected() {
      this.$emit("deselect-all"), this.selectedItems = [];
    },
    selectItems(e) {
      return e.reduce((l, s) => this.isItemDisabled(s) ? l : [...l, s], []);
    }
  }
}, je = { class: "tw-ll-grid tw-grid-cols-4 md:tw-grid-cols-8 lg:tw-grid-cols-12" }, Me = ["disabled"], Ge = { class: "button-grid tw-col-span-1 tw-items-end tw-justify-end lg:tw-col-span-3" }, Ue = {
  key: 0,
  class: "tw-text-xs"
};
function Ke(e, l, s, p, i, t) {
  const c = d("Icon"), g = d("Button"), I = d("Input"), x = d("Badge"), C = d("Filters"), z = d("Expand"), H = d("Dropdown"), j = d("Checkbox"), M = d("BulkActions"), G = d("Paginate"), U = O("sticky");
  return a(), o("div", null, [
    t.showPrimaryControls || t.showSecondaryControls ? (a(), o("div", {
      key: 0,
      ref: "scrollTarget",
      class: r(["tw-mb-6", { "tw-ll-grid": t.showPrimaryControls && t.showSecondaryControls }])
    }, [
      t.showPrimaryControls ? (a(), o("div", {
        key: 0,
        class: r(["controls", [e.$style["legacy-box"], { "tw-col-span-12 lg:tw-col-span-6": t.showSecondaryControls }]]),
        "data-test": "filters|controls"
      }, [
        u("div", je, [
          t.internalSearchSchema.isSearchable ? (a(), h(I, {
            key: 0,
            ref: "search-input",
            modelValue: i.searchTerm,
            "onUpdate:modelValue": l[1] || (l[1] = (y) => i.searchTerm = y),
            class: r(["tw-col-span-3 md:tw-col-span-4", [e.$style["search-input"], { "lg:tw-col-span-8": t.showSecondaryControls }]]),
            "data-test": "input|search-input",
            "hint-text": t.internalSearchSchema.hintText,
            label: i.searchText,
            placeholder: t.internalSearchSchema.placeholder,
            onKeyup: l[2] || (l[2] = q((y) => !t.isLoading && t.onSearch(), ["enter"])),
            onChange: t.onSearchTermChange
          }, {
            append: m(() => [
              i.searchTerm ? (a(), o("button", {
                key: 0,
                "data-test": "button|clear-search",
                class: r(e.$style["clear-button"]),
                disabled: t.isLoading,
                onClick: l[0] || (l[0] = (...y) => t.clearSearchTerm && t.clearSearchTerm(...y))
              }, [
                S(c, { name: "close" })
              ], 10, Me)) : n("", !0),
              S(g, {
                "data-test": "button|search-button",
                disabled: t.isLoading,
                class: r(e.$style["search-button"]),
                onClick: t.onSearch
              }, {
                default: m(() => [
                  S(c, {
                    class: r({ "tw-animate-spin tw-text-teal-500": i.isFiltering }),
                    name: i.isFiltering ? "working" : "search"
                  }, null, 8, ["class", "name"])
                ]),
                _: 1
              }, 8, ["disabled", "class", "onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "class", "hint-text", "label", "placeholder", "onChange"])) : n("", !0),
          s.filterSchema.length ? (a(), o("div", {
            key: 1,
            class: r(["tw-col-span-1 tw-flex tw-items-end", [
              e.$style["filter-toggle-btn"],
              { [e.$style["filter-toggle-btn-with-hint-text"]]: !!t.internalSearchSchema.hintText }
            ]])
          }, [
            S(x, { content: t.numberOfFilters }, {
              default: m(() => [
                S(g, {
                  secondary: "",
                  class: "tw-relative tw-w-full tw-min-w-auto",
                  color: "blue",
                  "data-test": "button|toggle-filters",
                  disabled: i.isFiltering,
                  onClick: t.onFiltersToggleClick
                }, {
                  default: m(() => [
                    i.isFiltering ? (a(), h(c, {
                      key: 0,
                      name: "working",
                      class: r([
                        { "tw-animate-spin": i.isFiltering },
                        i.isShowingFilters ? "tw-text-teal-500" : "tw-text-ice-700"
                      ])
                    }, null, 8, ["class"])) : (a(), h(c, {
                      key: 1,
                      name: "filter-line"
                    })),
                    T(" " + _(i.filterText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["content"])
          ], 2)) : n("", !0),
          u("div", Ge, [
            f(e.$slots, "actions")
          ])
        ]),
        S(z, {
          "data-test": "filters|content",
          class: r(e.$style["filters-expand"]),
          "is-expanded": i.isShowingFilters
        }, {
          default: m(() => [
            u("div", {
              class: r(["tw-relative tw-pt-12", e.$style["filters-wrapper"]])
            }, [
              S(C, {
                ref: "llFilters",
                class: r({ [e.$style["filters-half-width"]]: t.showPrimaryControls && t.showSecondaryControls }),
                "disable-apply": t.isLoading,
                "disable-clear": t.isLoading || !t.numberOfFilters,
                "disable-persistency": s.disablePersistency,
                schema: s.filterSchema,
                "validation-schema": s.validationSchema,
                onChange: l[3] || (l[3] = (y) => i.filters = y),
                onReset: t.reset,
                onSubmit: t.onFilter
              }, null, 8, ["class", "disable-apply", "disable-clear", "disable-persistency", "schema", "validation-schema", "onReset", "onSubmit"])
            ], 2)
          ]),
          _: 1
        }, 8, ["class", "is-expanded"])
      ], 2)) : n("", !0),
      t.showSecondaryControls ? (a(), o("div", {
        key: 1,
        class: r(["secondary-controls", [e.$style["legacy-box"], { "tw-col-span-12 tw-mt-0 lg:tw-col-span-6": t.showPrimaryControls }]])
      }, [
        f(e.$slots, "secondary-controls")
      ], 2)) : n("", !0)
    ], 2)) : n("", !0),
    f(e.$slots, "eyebrow"),
    t.shouldShowTotal || Object.keys(s.sorts).length ? (a(), o("div", {
      key: 1,
      class: r(["tw-mb-1.5", t.shouldShowTotal ? e.$style["total-sort"] : "tw-text-right"])
    }, [
      t.shouldShowTotal ? (a(), o("div", Ue, _(t.total), 1)) : n("", !0),
      Object.keys(s.sorts).length ? (a(), h(H, {
        key: 1,
        class: r(e.$style.dropdown),
        label: `${s.sortLabel} ${i.sortTerm}`,
        onToggleOnce: t.onSortToggle
      }, {
        default: m(() => [
          u("ul", {
            ref: "sortOptions",
            class: "dropdown__list",
            style: Y({ minWidth: i.sortOptionsWidth })
          }, [
            (a(!0), o(J, null, Q(Object.keys(s.sorts), (y, K) => (a(), o("li", {
              key: K,
              class: r([{ "tw-bg-blue-100 tw-text-ice-700": y === i.sortTerm }, "dropdown__item tw-rounded"])
            }, [
              S(g, {
                inline: "",
                class: r(["tw-items-center", e.$style["sort-option"]]),
                onClick: (qe) => t.onSort(y)
              }, {
                default: m(() => [
                  T(_(y) + " ", 1),
                  y === i.sortTerm ? (a(), h(c, {
                    key: 0,
                    name: "check",
                    class: "tw-ml-auto tw-text-blue-500"
                  })) : n("", !0)
                ]),
                _: 2
              }, 1032, ["class", "onClick"])
            ], 2))), 128))
          ], 4)
        ]),
        _: 1
      }, 8, ["class", "label", "onToggleOnce"])) : n("", !0)
    ], 2)) : n("", !0),
    t.useDefinedSlots ? (a(), o("div", {
      key: 2,
      class: r(e.$style["list-items"])
    }, [
      E((a(), o("header", {
        "data-test": "header|defined-slot",
        class: r([[
          e.$style.header,
          {
            "tw-m-0": !s.isSelectable
          }
        ], "tw-rounded"])
      }, [
        u("div", {
          class: r([e.$style["header-grid-container"], "tw-border-b tw-border-ice-200 tw-px-3"])
        }, [
          s.isSelectable ? (a(), h(j, {
            key: 0,
            class: r(["tw-ml-3", e.$style["select-all"]]),
            checked: t.isSomePageChecked,
            indeterminate: t.isSomePageChecked && !t.isAllPageChecked,
            "onUpdate:checked": t.onSelectPage
          }, null, 8, ["checked", "class", "indeterminate", "onUpdate:checked"])) : n("", !0),
          u("div", {
            class: r(["tw-ll-grid tw-flex-1", e.$style["header-grid"]])
          }, [
            f(e.$slots, "list-header")
          ], 2)
        ], 2),
        s.isSelectable ? (a(), h(M, X({ key: 0 }, {
          allowSelectAll: !s.hideSelectAll && !s.isServerSide,
          isAllPageChecked: t.isAllPageChecked,
          isSomePageChecked: t.isSomePageChecked,
          totalCount: t.totalCount,
          totalSelectedCount: t.totalSelectedCount,
          hideBulkActionOptions: s.hideBulkActionOptions,
          hideNumberOfTotalSelected: s.hideNumberOfTotalSelected
        }, {
          class: !t.isSelectBarVisible && "lg:tw-hidden",
          "onChange:clearSelected": t.clearSelected,
          "onChange:selectCurrent": t.onSelectPage,
          "onChange:selectAll": t.selectAll
        }), {
          "bulk-actions-content": m(() => [
            f(e.$slots, "bulk-actions", { selectedItems: i.selectedItems })
          ]),
          _: 3
        }, 16, ["class", "onChange:clearSelected", "onChange:selectCurrent", "onChange:selectAll"])) : n("", !0)
      ], 2)), [
        [U, t.headerOffset]
      ]),
      (a(), h(Z(s.disableLoader ? "div" : "LoadingManager"), {
        "empty-state-text": s.emptyStateText,
        loading: t.isLoading,
        results: t.paginated
      }, {
        default: m(() => [
          f(e.$slots, "list-items", {
            clearAll: t.clearSelected,
            displayItems: i.results,
            isFiltered: t.isFiltered,
            isItemDisabled: s.isItemDisabled,
            results: t.paginated,
            onSelect: t.onSelectItem,
            selectedItems: i.selectedItems
          })
        ]),
        _: 3
      }, 8, ["empty-state-text", "loading", "results"]))
    ], 2)) : n("", !0),
    f(e.$slots, "default", {
      currentPage: i.currentPage,
      displayItems: i.results,
      filters: i.filters,
      isFiltered: t.isFiltered,
      isItemDisabled: s.isItemDisabled,
      results: t.paginated,
      searchTerm: i.searchTerm,
      total: t.totalCount
    }),
    t.totalCount > s.pageSize ? (a(), h(G, {
      key: 3,
      "current-page": i.currentPage,
      "list-length": t.totalCount,
      "page-size": s.pageSize,
      onSetPage: t.onPaginateSetPage
    }, null, 8, ["current-page", "list-length", "page-size", "onSetPage"])) : n("", !0)
  ]);
}
const We = {
  $style: ze
}, St = /* @__PURE__ */ k(He, [["render", Ke], ["__cssModules", We]]);
export {
  pe as BulkActions,
  gt as ListGroup,
  ft as ListHeader,
  Te as LoadingManager,
  St as default
};
//# sourceMappingURL=ListView.js.map
